module.exports = __webpack_public_path__ + "img/yalobusha-review-3.e0cb203a.png";